//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DivSpan from '@/components/DivSpan';
export default {
  name: "purchase-order-confirm",
  components:{DivSpan},
  data() {
    return {
      codeSort: 'DESC',
      page: 0,
      wrapperHeight: 0,
      allLoaded: false,
      userType: null,
      searchData: {},
      orderList: [],
    }
  },
  methods: {
    clear(){
      delete  this.searchData['orderNo'];
      this.getOrderList()
    },
    searchList(searchData){
      this.searchData= Object.assign(searchData,this.searchData);
      this.getOrderList()
    },
    goFlow(order){
      if(order.requestId){
        console.log("order:", order)
        let title = order.supplierName;
        let orderNo = order.orderTypeName + " | " + order.orderNo
        this.$router.push('/workflow/'+order.requestId+'?component=ViewOrderDetailComponent&orderNo='+orderNo +"&title="+title);
      }
    },
    init: function () {
      // 父控件要加上高度，否则会出现上拉不动的情况
      if(this.$store.state.device === 'wap'){
        this.wrapperHeight =
          document.documentElement.clientHeight -
          this.$refs.wrapper.getBoundingClientRect().top ;
      }else{
        this.wrapperHeight =
          document.documentElement.clientHeight -
          this.$refs.wrapper.getBoundingClientRect().top ;
      }

    },
    //点击搜索按钮
    searchOrder(){
      this.getOrderList();
    },
    loadTop() {
      this.$search('api/purOrder', {
        sort: 'createdDate,' + this.codeSort,
        page: 0,
        size: 10,
        searchType: 0,
        workflowId: this.workflowId
      }, this.searchData).then(list => {
        this.orderList = list;
        this.$refs.loadmore.onTopLoaded();
      }).catch((error) => {
        this.$refs.loadmore.onTopLoaded();
      });
    },
    loadBottom() {
      this.page++;
      this.$search('api/purOrder', {
        sort: 'createdDate,' + this.codeSort,
        page: this.page,
        size: 10,
        searchType: 0,
        workflowId: this.workflowId
      }, this.searchData).then(list => {
        if(list.length==0){
          this.$vux.toast.text('已经加载全部')
          this.$refs.loadmore.onBottomLoaded();
          return;
        }
        this.orderList = this.orderList.concat(list);
      }).catch((error) => {
        this.$refs.loadmore.onBottomLoaded();
      });
    },
    //获取全部订单
    getOrderList(){
      this.$loadingShow();
      this.$search('api/purOrder', {
        sort: 'createdDate,' + this.codeSort,
        page: 0,
        size: 10,
        searchType: 0,
        workflowId: this.workflowId
      }, this.searchData).then(list => {
        this.orderList = list;
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
      });
    },
    getWorkflowId(){
      this.$get('api/biz-object-parameters/key/purOrder').then(data=>{
        this.workflowId=data.workflowType;
        this.getOrderList();

      })}
  },
  mounted() {
    this.init();
    this.getWorkflowId()
  }
}




// WEBPACK FOOTER //
// ./src/page/purchase-order/purchase-order-confirm.vue